import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (t) => [
    {
        label: t('discover.category.entities_table.entity_name'),
        key: 'entity_name',
        data: 'entity_name',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <a
                    style={{ fontWeight: 600 }}
                    href={
                        `/domains/${window.info.id}/entities/entity?entities:in=` +
                        encodeURIComponent(data)
                    }
                    target="_blank"
                    rel="noreferrer"
                >
                    {data}
                </a>
            );
        },
    },
    {
        label: t('discover.category.entities_table.pages'),
        key: 'pages',
        data: 'pages',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('discover.category.entities_table.total_impressions'),
        key: 'total_impressions',
        data: 'total_impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.category.entities_table.total_clicks'),
        key: 'total_clicks',
        data: 'total_clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.category.entities_table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.total_clicks / item.total_impressions;
            if (csvDownload) return ctrValue;

            return (
                <div>
                    <strong>{numeral(ctrValue).format('0.00%')}</strong>{' '}
                </div>
            );
        },
    },
];
